import React from 'react';

import {ActionPlanImpactLevel, CategoryKeyEnum} from '#apollo/schema';
import {Icon, Text} from '#component/base';
import {ImpactImage} from '#component/page/ActionPlan/components/ImpactImage';
import {ImpactTag} from '#component/page/ActionPlan/components/ImpactTag';
import {sprinkles} from '#style/sprinkles';
import {getCategoryIconName} from '#util';

export interface GoalsHeaderProps {
  title: string;
  subtitle: string;
  impactLevel?: ActionPlanImpactLevel;
  categoryKey: CategoryKeyEnum;
  imageUrl?: string;
  onClick?: () => void;
}

function GoalsListItem({
  title,
  subtitle,
  categoryKey,
  impactLevel,
  imageUrl,
  onClick = () => {},
}: GoalsHeaderProps) {
  return (
    <div
      onClick={onClick}
      className={sprinkles({
        display: 'flex',
        dir: 'col',
        gap: 24,
        w: 'full',
        p: 24,
        bg: 'white',
      })}>
      <div
        className={sprinkles({
          display: 'flex',
          items: 'center',
          content: 'between',
          placeContent: 'between',
          w: 'full',
        })}>
        <ImpactImage imageUrl={imageUrl} impactLevel={impactLevel} />
        <ImpactTag impactLevel={impactLevel} />
      </div>
      <div
        className={sprinkles({
          display: 'flex',
          dir: 'col',
          gap: 8,
        })}>
        <Text
          as="p"
          color="deepBurgundy"
          variant="body"
          fontWeight="semiBold"
          className={sprinkles({
            display: 'flex',
            items: 'center',
            gap: 12,
          })}>
          <Icon name={getCategoryIconName(categoryKey)} color="deepBurgundy" />
          {title}
        </Text>
        <Text as="p" variant="bodyLarge">
          {subtitle}
        </Text>
      </div>
      <Text
        color="eggplantDark"
        variant="buttonSmall"
        fontWeight="semiBold"
        className={sprinkles({
          display: 'flex',
          gap: 8,
          items: 'center',
        })}>
        Explore goal
        <Icon name="CaretDown" size="small" color="currentColor" weight="bold" />
      </Text>
    </div>
  );
}
export {GoalsListItem};
